import React from 'react';

interface StatusBadgeProps {
  label: string;
  bgColorClass?: string;
  textColorClass?: string;
  className?: string;
}

const StatusBadgeCommon: React.FC<StatusBadgeProps> = ({
  label,
  bgColorClass = 'bg-green-500',
  textColorClass = 'text-white',
  className = '',
}) => {
  return (
    <div
      className={`h-8 px-3 max-w-fit rounded-full inline-flex justify-center items-center gap-1 ${bgColorClass} ${className}`}
    >
      <div className={`text-center text-sm font-medium leading-tight ${textColorClass}`}>{label}</div>
    </div>
  );
};

export default StatusBadgeCommon;
